import {
	type IApplyColorToProps,
	type IIconVariation,
	type IWithIconStylesHoC,
	withIconStyles,
} from './withIconStyles';

import ArrowBack from '../../assets/arrow-back.svg';
import ArrowForward from '../../assets/arrow-forward.svg';
import Article from '../../assets/article.svg';
import Close from '../../assets/close.svg';
import ChevronUp from '../../assets/chevron-up.svg';
import ChevronDown from '../../assets/chevron-down.svg';
import ChevronLeft from '../../assets/chevron-left.svg';
import ChevronRight from '../../assets/chevron-right.svg';
import Instagram from '../../assets/instagram.svg';
import Info from '../../assets/info.svg';
import Pdf from '../../assets/pdf.svg';
import Download from '../../assets/download.svg';
import ExternalLink from '../../assets/external-link.svg';
import Phone from '../../assets/phone.svg';
import Search from '../../assets/search.svg';
import YouTube from '../../assets/youtube.svg';
import Check from '../../assets/check.svg';
import Car from '../../assets/car.svg';
import Warning from '../../assets/warning.svg';
import Email from '../../assets/email.svg';
import XLogo from '../../assets/x-logo.svg';
import Filter from '../../assets/filter.svg';
import Image from '../../assets/image.svg';
import Plus from '../../assets/plus.svg';
import Menu from '../../assets/menu.svg';
import FlightUp from '../../assets/flight-up.svg';
import FlightArrival from '../../assets/flight-arrival.svg';
import FlightDeparture from '../../assets/flight-departure.svg';
import ShopAndDine from '../../assets/shop-and-dine.svg';
import Security from '../../assets/security.svg';
import Alerts from '../../assets/alerts.svg';
import Accessibility from '../../assets/accessibility.svg';
import Valet from '../../assets/valet.svg';
import EV from '../../assets/ev.svg';
import SecurityRight from '../../assets/security-right.svg';
import SecurityMiddle from '../../assets/security-middle.svg';
import SecurityLeft from '../../assets/security-left.svg';
import SearchWrong from '../../assets/search-wrong.svg';
import Calendar from '../../assets/calendar.svg';
import Clock from '../../assets/clock.svg';
import Refresh from '../../assets/refresh.svg';
import Map from '../../assets/map.svg';
import Mic from '../../assets/mic.svg';
import WeatherSunny from '../../assets/weather-sunny.svg';
import WeatherCloudy from '../../assets/weather-cloudy.svg';
import WeatherFog from '../../assets/weather-fog.svg';
import WeatherStorm from '../../assets/weather-thunder.svg';
import WeatherRain from '../../assets/weather-rain.svg';
import WeatherBrokenClouds from '../../assets/weather-broken-clouds.svg';
import WeatherSnow from '../../assets/weather-snow.svg';
import Dine from '../../assets/dine.svg';
import Shop from '../../assets/shop.svg';
import Services from '../../assets/services.svg';
import Drink from '../../assets/drink.svg';
import Facebook from '../../assets/facebook.svg';
import LinkedIn from '../../../assets/icons/socials/linkedin.svg';
import Language from '../../../assets/icons/language.svg';
import Notes from '../../assets/notes.svg';
import Receipt from '../../assets/receipt.svg';
import Eye from '../../assets/eye.svg';
import Play from '../../assets/play-icon.svg';

export const ArrowBackIcon = withIconStyles(ArrowBack);
export const ArrowForwardIcon = withIconStyles(ArrowForward);
export const ArticleIcon = withIconStyles(Article);
export const CloseIcon = withIconStyles(Close);
export const ChevronDownIcon = withIconStyles(ChevronDown);
export const ChevronLeftIcon = withIconStyles(ChevronLeft);
export const ChevronRightIcon = withIconStyles(ChevronRight);
export const ChevronUpIcon = withIconStyles(ChevronUp);
export const CheckIcon = withIconStyles(Check);
export const CarIcon = withIconStyles(Car);
export const InstagramIcon = withIconStyles(Instagram);
export const InfoIcon = withIconStyles(Info);
export const DownloadIcon = withIconStyles(Download);
export const PdfIcon = withIconStyles(Pdf);
export const ExternalLinkIcon = withIconStyles(ExternalLink);
export const PhoneIcon = withIconStyles(Phone);
export const SearchIcon = withIconStyles(Search);
export const YouTubeIcon = withIconStyles(YouTube);
export const WarningIcon = withIconStyles(Warning);
export const EmailIcon = withIconStyles(Email);
export const XLogoIcon = withIconStyles(XLogo);
export const FilterIcon = withIconStyles(Filter);
export const ImageIcon = withIconStyles(Image);
export const PlusIcon = withIconStyles(Plus);
export const MenuIcon = withIconStyles(Menu);
export const FlightUpIcon = withIconStyles(FlightUp);
export const FlightDepartureIcon = withIconStyles(FlightDeparture);
export const FlightArrivalIcon = withIconStyles(FlightArrival);
export const ShopAndDineIcon = withIconStyles(ShopAndDine);
export const SecurityIcon = withIconStyles(Security);
export const AlertsIcon = withIconStyles(Alerts);
export const AccessibilityIcon = withIconStyles(Accessibility);
export const ValetIcon = withIconStyles(Valet);
export const EVIcon = withIconStyles(EV);
export const SecurityRightIcon = withIconStyles(SecurityRight);
export const SecurityMiddleIcon = withIconStyles(SecurityMiddle);
export const SecurityLeftIcon = withIconStyles(SecurityLeft);
export const SearchWrongIcon = withIconStyles(SearchWrong);
export const RefreshIcon = withIconStyles(Refresh);
export const CalendarIcon = withIconStyles(Calendar);
export const ClockIcon = withIconStyles(Clock);
export const MapIcon = withIconStyles(Map);
export const MicIcon = withIconStyles(Mic);
export const WeatherSunnyIcon = withIconStyles(WeatherSunny);
export const WeatherCloudyIcon = withIconStyles(WeatherCloudy);
export const WeatherFogIcon = withIconStyles(WeatherFog);
export const WeatherStormIcon = withIconStyles(WeatherStorm);
export const WeatherRainIcon = withIconStyles(WeatherRain);
export const WeatherBrokenCloudsIcon = withIconStyles(WeatherBrokenClouds);
export const WeatherSnowIcon = withIconStyles(WeatherSnow);
export const DineIcon = withIconStyles(Dine);
export const ShopIcon = withIconStyles(Shop);
export const ServicesIcon = withIconStyles(Services);
export const DrinkIcon = withIconStyles(Drink);
export const FacebookIcon = withIconStyles(Facebook);
export const LinkedInIcon = withIconStyles(LinkedIn);
export const LanguageIcon = withIconStyles(Language);
export const NotesIcon = withIconStyles(Notes);
export const ReceiptIcon = withIconStyles(Receipt);
export const EyeIcon = withIconStyles(Eye);
export const PlayIcon = withIconStyles(Play);

export {
	withIconStyles,
	IWithIconStylesHoC,
	IIconVariation,
	IApplyColorToProps,
};

export * from './IIconProps';
